import useHttpPost from "./useHttpPost";

function usePostTransaction(target) {
  return useHttpPost("inspectiontype", "post", {}, target);
}

export default usePostTransaction;
